module.exports = __webpack_public_path__ + "static/media/financepic1@3x.f5df2af5.png";